import { render } from "./DefaultPromotion.vue?vue&type=template&id=d35b03f4&scoped=true"
import script from "./DefaultPromotion.vue?vue&type=script&lang=js"
export * from "./DefaultPromotion.vue?vue&type=script&lang=js"

import "./DefaultPromotion.vue?vue&type=style&index=0&id=d35b03f4&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d35b03f4"]])

export default __exports__